import './style.css';
import { Game } from './core/Game.js';

const game = new Game(document.getElementById('game'));
game.start();

// Instancia accesible desde la consola, REA y browser-check (también en la versión publicada:
// es un juego local de un jugador, no hay nada que proteger).
window.__dopamine = game;
